import classnames from 'classnames';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={classnames(
        'ui-animate-pulse ui-rounded-md ui-bg-gray-300',
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
